// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { env as envImpl } from './env-impl.js';
/**
 * Represent a set of flags as a global singleton.
 */
export const env = envImpl;
//# sourceMappingURL=env.js.map